// project import
import { overview, operations, catalog, plans, tools } from './dashboard';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [overview, operations, catalog, plans, tools]
};

export default menuItems;
